import { Component, inject, input } from '@angular/core';
import { Media } from '@app/models/media.model';
import { MobiUiIconComponent } from '@mobi/rwc-ui-components-ng-jslib';
import { Renderer2 } from '@angular/core';
import { ComponentSharedModule } from '@app/modules/component.shared.module';
import { TealiumUtagService } from '@app/services/utag.service';
import { ApiService } from '@app/services/api.service';

@Component({
  selector: 'mobi-file-download',
  templateUrl: './file-download.component.html',
  styleUrls: ['./file-download.component.scss'],
  imports: [ComponentSharedModule, MobiUiIconComponent],
  standalone: true,
})
export class FileDownloadComponent {
  readonly id = input();
  readonly file = input<Media>();
  readonly type = input.required<'vcard' | 'image'>();

  #renderer = inject(Renderer2);
  #tealium = inject(TealiumUtagService);
  #api = inject(ApiService);

  async downloadVCard(): Promise<void> {
    const link = this.#renderer.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', `${this.#api.apiUrl}/api/vcard/${this.id()}`);
    link.click();
    link.remove();

    this.#tealium.link({
      tealium_event: 'document_download',
      download_url: 'vcard',
      download_filetyp: 'vcard',
      download_title: 'Kontakt speichern',
    });
  }

  downloadImage(value: Media): string {
    let url: string = '';
    if (value.image) {
      const rokkaHash = value.image?.entity?.rokka?.hash;
      if (rokkaHash && value.image?.entity?.filename) {
        const rokkaUrl = this.#api.rokkaUrl;
        url = rokkaUrl.concat(rokkaHash, '/', value.image?.entity?.filename);
      }
    }
    return url;
  }
}
